export default __webpack_public_path__ + "static/media/ke.c5f66beb.svg";